import React from 'react'
import Contact from '../../component/Contact/Contact'


const ContactUs = () => {
    return (
        <>
            <Contact/>
        </>
    )
}

export default ContactUs
